/*
 * @Author: daringuo
 * @Date: 2018-05-15 18:55:14
 * @Last Modified by:   daringuo
 * @Last Modified time: 2018-05-15 18:55:14
 */
export default {
  findNode(list, value) {
    const _recurse = (root, value) => {
      let result;
      if (root.value === value) {
        result = root;
      } else if (root.children && root.children.length) {
        for (let i = 0; i < root.children.length; i++) {
          const _res = _recurse(root.children[i], value);
          if (_res) {
            result = _res;
            break;
          }
        }
      }
      return result;
    };
    let res;
    for (let i = 0; i < list.length; i++) {
      const _res = _recurse(list[i], value);
      if (_res) {
        res = _res;
        break;
      }
    }
    return res;
  },
  getQueryString(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", 'i'); // 匹配目标参数
    const result = window.location.search.substr(1).match(reg); // 对querystring匹配目标参数
    if (result != null) {
      return decodeURIComponent(result[2]);
    }
    return null;
  },
  setQueryString(key, value) {
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newParam = key + '=' + value,
        params = '?' + newParam;

    if (urlQueryString) {
        let updateRegex = new RegExp('([\?&])' + key + '[^&]*');
        let removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

        if( typeof value == 'undefined' || value == null || value == '' ) {
            params = urlQueryString.replace(removeRegex, "$1");
            params = params.replace( /[&;]$/, "" );

        } else if (urlQueryString.match(updateRegex) !== null) {
            params = urlQueryString.replace(updateRegex, "$1" + newParam);

        } else {
            params = urlQueryString + '&' + newParam;
        }
    }
    params = params == '?' ? '' : params;
    window.history.replaceState({}, "", baseUrl + params);
  },
  dateFormat(date, str) {
      var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(str)) str = str.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
      if (new RegExp("(" + k + ")").test(str)) str = str.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return str;
  },
  getQBVertion() {
    var raw = navigator.userAgent.match(/QQBrowser\/([0-9]+\.[0-9]+)\./);
    return raw ? parseFloat(raw[1], 10) : false;
  }
};
